import React, { useState } from 'react';
import { FaBars, FaRegRectangleXmark, FaRss } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

function MobileSidebar() {
  const [state, setState] = useState(false);

  const updatebarstate = () => {
    setState(!state);
  };

  return (
    <>
      <div class="absolute right-0 flex flex-col gap-1 py-4 px-2 rounded-xl bg-secondary h-fit md:hidden">
        <div class="flex justify-end px-3 text-darkgrey text-2xl">
          {state ? (
            <FaRegRectangleXmark onClick={() => updatebarstate()} />
          ) : (
            <FaBars onClick={() => updatebarstate()} />
          )}
        </div>

        {state && (
          <div class="flex flex-col mt-2 py-2 px-6 gap-1 items-center font-semibold bg-primary text-darkgrey rounded-md">
            <Link
              to="https://wa.me/923062767542?text=Hi,%20I%20would%20like%20to%20hire%20you"
              class="font-sans py-1 text-lightgrey"
            >
              Hire Me
            </Link>
            <Link to="/" class="font-sans py-1">
              Home
            </Link>
            <hr class="w-full text-darkgrey rounded-full" />
            <Link to="/about" class="font-san py-1">
              About
            </Link>
            <hr class="w-full text-darkgrey rounded-full" />
            <Link to="/expertise" className="font-sans py-1">
              Expertise
            </Link>
            <hr class="w-full text-darkgrey rounded-full" />
            <Link to="/projects" class="font-sans py-1">
              Projects
            </Link>
            <hr class="w-full text-darkgrey rounded-full" />
            <Link to="/blogs" class="font-sans py-1">
              Blogs
            </Link>
            <hr class="w-full text-darkgrey rounded-full" />
            <Link to="/contact" class="font-sans py-1">
              Contact
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

export default MobileSidebar;
